import { render, staticRenderFns, recyclableRender, components } from "./sunui-mverify.vue?vue&type=template&id=b5b39910&name=sunui-mverify&"
var renderjs
import script from "./sunui-mverify.vue?vue&type=script&lang=js&"
export * from "./sunui-mverify.vue?vue&type=script&lang=js&"
import style0 from "./sunui-mverify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/sunui-mverify/sunui-mverify.vue"
export default component.exports